import { Skeleton } from "@/components/ui/skeleton";

interface EntityListLoadingStateProps {
  rows?: number;
  rowClassName?: string;
  containerClassName?: string;
}

export function EntityListLoadingState({
  rows = 6,
  rowClassName = "h-14 w-full",
  containerClassName = "p-3 space-y-2",
}: EntityListLoadingStateProps) {
  return (
    <div className={containerClassName}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} className={rowClassName} />
      ))}
    </div>
  );
}

interface EntityListEmptyStateProps {
  text: string;
  className?: string;
}

export function EntityListEmptyState({
  text,
  className = "p-8 text-center text-muted-foreground text-sm",
}: EntityListEmptyStateProps) {
  return <div className={className}>{text}</div>;
}

